import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/downloads/$")({
  beforeLoad: () => {
    // Real PDFs under public/downloads are served statically; anything else
    // falls back to the homepage.
    throw redirect({ href: "/", statusCode: 302, replace: true });
  },
});
